// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 3H1V14H23V3Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 16H1V19H11V20H7V22H17V20H13V19H23V16Z"}}]};

const Desktop1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'desktop-1-filled',
    ref,
    icon: element,
  },
));

Desktop1FilledIcon.displayName = 'Desktop1FilledIcon';

export default Desktop1FilledIcon;
